import React from 'react';

export default function HomeFeedScopeToggle({
  homeFeedScope,
  setHomeFeedScope,
  homeSearchTerm,
  compact = false,
}) {
  return (
    <div className={`rounded-xl border border-slate-700 ${compact ? 'bg-slate-900/30 p-2.5' : 'bg-slate-800/50 p-3'}`}>
      <div className="flex items-center justify-between gap-3">
        {!compact ? (
          <div className="text-xs uppercase tracking-wide text-slate-400">Feed scope</div>
        ) : (
          <div className="text-[11px] text-slate-500">Switch feed</div>
        )}
        <div className="inline-flex rounded-lg border border-slate-700 bg-slate-900/70 p-1">
          <button
            onClick={() => setHomeFeedScope('all')}
            className={`px-3 py-1 text-xs font-semibold rounded-md transition ${homeFeedScope === 'all' ? 'bg-purple-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}
          >
            All
          </button>
          <button
            onClick={() => !homeSearchTerm.trim() && setHomeFeedScope('following')}
            disabled={!!homeSearchTerm.trim()}
            className={`px-3 py-1 text-xs font-semibold rounded-md transition ${homeFeedScope === 'following' ? 'bg-purple-600 text-white' : 'text-slate-300 hover:bg-slate-800'} disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            Following
          </button>
          <button
            onClick={() => !homeSearchTerm.trim() && setHomeFeedScope('crews')}
            disabled={!!homeSearchTerm.trim()}
            className={`px-3 py-1 text-xs font-semibold rounded-md transition ${homeFeedScope === 'crews' ? 'bg-purple-600 text-white' : 'text-slate-300 hover:bg-slate-800'} disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            My Crews
          </button>
        </div>
      </div>
      {!compact && homeSearchTerm.trim() ? (
        <div className="mt-2 text-[11px] text-slate-500">Clear search to view Following or My Crews.</div>
      ) : !compact && homeFeedScope === 'following' ? (
        <div className="mt-2 text-[11px] text-slate-500">Showing trials created by people you follow.</div>
      ) : !compact && homeFeedScope === 'crews' ? (
        <div className="mt-2 text-[11px] text-slate-500">Showing trials created by members of your crews.</div>
      ) : null}
    </div>
  );
}
